<div *ngIf="data.paymentOptions === undefined">
  <div class="remove-vehicle-confirmation">
    <p class="font-18 confirmation-text-non-default {{isWebView ? 'text-color': ''}}">
      Are you sure you want to remove {{ data.cc_type }} **** **** ****
      {{ data.suffix }} ?
    </p>
    <div *ngIf="!isWebView; else btnStyle">
      <div class="action-btn-container">
        <button mat-flat-button class="button-new standard-btn danger-btn" (click)="onCancel()">
          Cancel
        </button>
        <button mat-flat-button class="button-new standard-btn primar-btn" (click)="onConfirmRemove()">
          Remove
        </button>
      </div>
    </div>
    <ng-template #btnStyle>
      <div class="container-buttons-wv flex-column-wv">
        <button mat-button class="button-with-radius standard-btn" (click)="onConfirmRemove()">
          Remove
        </button>
        <button mat-button class="button-wv standard-btn" (click)="onCancel()">
          Cancel
        </button>
      </div>
    </ng-template>
  </div>
</div>
<div *ngIf="data.paymentOptions !== undefined">
  <div class="remove-vehicle-confirmation">
    <p class="font-18 confirmation-text text-center-align {{isWebView ? 'text-color': ''}}">
      Do you want to remove <br> {{ data.card.cc_type }} *{{ data.card.suffix }}?
    </p>
    <div>
      <div>
        <p class="font-14 {{isWebView ? 'text-color': 'choice-text'}}">
          Select a new default payment method.
        </p>
      </div>
      <div class="payment-options">
        <mat-radio-group aria-labelledby="example-radio-group-label" class="example-radio-group">
          <mat-radio-button class="example-radio-button" *ngFor="let payment of data.paymentOptions; trackBy: trackByNgForItem" [value]="payment"
            (change)="radioChange($event, payment)" checked="{{data.paymentOptions.length === 1 ? true : false}}">
            <div class="card-data">
              <span
                class="font-14  {{isWebView ? 'text-color font-weight-600': 'black-color'}}">{{payment.cc_type.toUpperCase()}}
                *{{payment.suffix}}</span>
              <span class="font-14  {{isWebView ? 'text-color': 'black-color'}}">Exp
                {{ payment.cc_expire_mm + "/" + payment.cc_expire_yyyy.toString().slice(2)}}</span>
            </div>
          </mat-radio-button>
        </mat-radio-group>
      </div>
    </div>
    <div *ngIf="!isWebView; else btnStyle">
      <div class="action-btn-container">
        <button mat-flat-button class="button standard-btn danger-btn" (click)="onCancel()">
          Cancel
        </button>
        <button mat-flat-button class="button standard-btn primar-btn" (click)="onConfirmRemove()"
          [disabled]="!isSelected">
          Remove
        </button>
      </div>
    </div>
    <ng-template #btnStyle>
      <div class="container-buttons-wv flex-column-wv">
        <button mat-button class="button-with-radius standard-btn" (click)="onConfirmRemove()" [disabled]="!isSelected">
          Remove
        </button>
        <button mat-button class="button-wv standard-btn" (click)="onCancel()">
          Cancel
        </button>
      </div>
    </ng-template>
  </div>
</div>
